<template>
  <div id="legalNotice" class="d-flex flex-column justify-content-around align-items-left" v-if="legalNoticeLg.lg1.length > 0">
    <div id="bloc1" v-if="legalNoticeLg.lg1">
      <div>
        <span class="lg1 subtitle" v-html="rawHtml(legalNoticeLg.lg1[1].ta_value)"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IbisStylesRatesHorizontalV1LegalNoticeCenter',
  props: {
    legalNoticeLg: Object
  },
  methods: {
    rawHtml (value) {
      return value
    }
  }
}
</script>


<style lang="scss" scoped>
  $srcWidth: 1920;
  $srcHeight: 1200;
  @import "../../../../_ibisstyles.scss";

  #legalNotice {
    font-family: "Gotham-Book";
    @include fontSize(27);
    line-height: 1.2em;

    position: absolute;
    bottom: 45px;
    @include widthPercent(742);
    @include heightPercent(96);
    justify-content: space-evenly!important;

    span+span:not(:empty):before {
      content: '- ';
    }

    .subtitle::first-letter {
      text-transform: uppercase;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ibisstyles/rates/horizontal/v1/services/legalNoticeCenter.vue